import "./TextError.scss";
import { GoAlert } from "react-icons/go";

const TextError = (props) => {
    return(
        <p className="error"><GoAlert /> {props.text ? props.text : props.children}</p>
    )
}

export default TextError